import { IconCheck } from "@tabler/icons";
import { Avatar } from "@mantine/core";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { isMobile } from "react-device-detect";
import { Fragment, useEffect, useState } from "react";
import { useRedirectAnonymous } from "../../../../../hooks/auth/useRedirectAnonymous";
import { MyHead } from "../../../../../components/pages/MyHead";
import { Container } from "../../../../../components/UI/container/Container";
import { MyH1 } from "../../../../../components/UI/my-h1/MyH1";
import { MyButton } from "../../../../../components/UI/my-button/MyButton";
import { useColors } from "../../../../../hooks/colors/useColors";
import useAsyncEffect from "use-async-effect";
import { usePayment } from "../../../../../components/pages/user/appointments/payments/usePayment";
import { useJWT } from "../../../../../hooks/react-query/useJWT";
import {
  queryClient,
  QueryKeys,
} from "../../../../../hooks/react-query/query-client";
import { Footer } from "../../../../../components/pages/homepage/footer/Footer";

// @ts-ignore
export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common"])),
    },
  };
}

function PaymentSuccessPage() {
  const { colors } = useColors();
  const redirect = useRedirectAnonymous();
  const router = useRouter();
  const { t } = useTranslation("common");
  const { jwt } = useJWT();
  const { sendCCPaymentStatus } = usePayment();
  const [retry, setRetry] = useState<boolean>(false);

  useAsyncEffect(async () => {
    const { requestId, retry } = router.query;

    if (typeof retry === "undefined" && requestId && jwt) {
      const status: number = await sendCCPaymentStatus(
        requestId.toString(),
        jwt,
        "PAID"
      );
      if (status !== 200) {
        await router.push("/user/payment/itp/error");
      }
    }

    if (retry) {
      setRetry(true);
    }
  }, [router.query && jwt]);

  async function goBack() {
    await queryClient.invalidateQueries(QueryKeys.APPOINTMENTS);
    await router.push("/user");
  }

  return (
    <Fragment>
      <MyHead
        title={t("payment.success-message")}
        description={t("payment.success-message")}
      />
      <Container noHeight>
        <div
          style={{ minHeight: "calc(100vh - 300px)" }}
          className="flex flex-col justify-center items-center gap-4"
        >
          <Avatar
            styles={{ placeholder: { backgroundColor: colors.success } }}
            radius={150}
            size={300}
          >
            <IconCheck size={300} color={colors.white} />
          </Avatar>
          <MyH1 size={isMobile ? "2.5rem" : "3rem"} centerText>
            {t(
              !retry
                ? `payment.success-message`
                : "payment.retry-success-message"
            )}
          </MyH1>
          <MyButton
            marginTop
            size="xl"
            fontSize="1.5rem"
            height="3rem"
            onClick={goBack}
            title={t("backProfile")}
            color={colors.secondary}
          />
        </div>
      </Container>
      <Footer isVisible />
    </Fragment>
  );
}

export default PaymentSuccessPage;
